import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StrictMode } from "react";

/** elements here */
import { NotFound } from "./features/errors/not-found";
import { HomePage } from "./features/home/homepage";

/** styles here */
import "./index.css";
import "./styles/buttons.css";
import "./styles/spacings.css";
import "./styles/header.css";
import "./styles/fonts.css";
import "./styles/chat.css";
import "./styles/home.css";
import "./styles/countries.css";
import "./styles/footer.css";
import "./styles/services.css";
import "./App.css";

import { Schools } from "./features/schools/schools";
import { Gallery } from "./features/gallery/gallery";
import { VisaPage } from "./features/visas/visas";
import { Services } from "./features/services/services";

/** context apis */
import { LanguageContextProvider } from "./services/languages.context";
import { AboutUs } from "./features/about/about";
import { BlogPage } from "./features/blog/blog";

function App() {
  return (
    <StrictMode>
        <BrowserRouter>
          <LanguageContextProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/schools" element={<Schools />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/visa-programs" element={<VisaPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="*" element={<NotFound/>} />
            </Routes>
          </LanguageContextProvider>
        </BrowserRouter>
    </StrictMode>
  );
}

export default App;
